import ApiService from "./ApiService";

const ROOT_URL = "/services/onboarding/api/leadparty/private";

const LeadPartyApi = new ApiService(ROOT_URL, "", {
  createLeadParty: function (ctx, data, onSuccess, onError) {
    this.apiPOST(ctx, "/create", data, onSuccess, onError);
  },
  findAll: function (ctx, data, onSuccess, onError) {
    this.apiPOST(ctx, "/findall", data, onSuccess, onError);
  },
  findallhistoric: function (ctx, data, onSuccess, onError) {
    this.apiPOST(ctx, "/findallhistoric", data, onSuccess, onError);
  },
  findallreporting: function (ctx, data, onSuccess, onError) {
    this.apiPOST(ctx, "/findallreporting", data, onSuccess, onError);
  },
  findAllNamesLeadParty: function (ctx, domainId, type, partyStatuses, onSuccess, onError) {
    this.apiGET(
      ctx,
      `/findallnames?domainId=${domainId}` +
      (type != null ? "&type=" + type : "") + "&partyStatuses=" + partyStatuses,
      onSuccess,
      onError
    );
  },
  get: function (ctx, leadPartyId, onSuccess, onError) {
    this.apiGET(ctx, "/findbyid?id=" + leadPartyId, onSuccess, onError);
  },
  checkTckn: function (ctx, tckn, onSuccess, onError) {
    this.apiGET(ctx, "/checktckn?tckn=" + tckn, onSuccess, onError);
  },
  deleteProcessByLeadId: function (ctx, processId, leadId, onSuccess, onError) {
    this.apiDELETE(
      ctx,
      `/deleteprocessbylead?processId=${processId}&leadId=${leadId}`,
      onSuccess,
      onError
    );
  },
  deleteMultiple: function (ctx, ids, onSuccess, onError) {
    this.apiDELETE(ctx, "/multiple/" + ids, onSuccess, onError);
  },
  assignInitiator: function (ctx, processId, data, onSuccess, onError) {
    this.apiPOST(ctx, "/" + processId + "/assign-initiator", data, onSuccess, onError);
  }
  ,
  getLeadPartyNfcInfo: function (ctx, processId, onSuccess, onError) {
    this.apiGET(ctx, "/nfcreadstatus/" + processId, onSuccess, onError);
  }
});

export default LeadPartyApi;


// WEBPACK FOOTER //
// ./src/service/LeadPartyService.js